import { prepUrlForEnvironment } from '@sureapp/wl-toggle-common/dist/utils/url';

import { ReactComponent as TenantAlertIcon } from '../../../common/assets/carvana/image/carvana-alert-icon.svg';
import { ReactComponent as carvanaCobrandLogo } from '../../../common/assets/carvana/image/carvana-cobrand-logo.svg';
import carvanaCoverageShield from '../../../common/assets/carvana/image/carvana-coverage-shield.svg';
import carvanaFamily from '../../../common/assets/carvana/image/carvana-family.svg';
import tenantFinalImg from '../../../common/assets/carvana/image/carvana-final-buckle-up.svg';
import tenantCityImg from '../../../common/assets/carvana/image/carvana-little-city.svg';
import carvanaSmileyCarWithSparkles from '../../../common/assets/carvana/image/carvana-smiley-car-with-sparkles.svg';
import carvanaSmileyCar from '../../../common/assets/carvana/image/carvana_smile_car.svg';

const mfaSuccessHost = prepUrlForEnvironment({
  url: process.env.REACT_APP_MFA_SUCCESS_REDIRECT_HOST,
});

const config = {
  buckleUpConfig: {
    defaultHeader: 'Hang tight',
    hasPhantomCircleDeterminate: true,
    tenantDesktopBuckleUpImg: null,
    tenantFinalImg,
    tenantFinalTopImg: null,
    tenantMobileBuckleUpImg: null,
    tenantTopImg: carvanaSmileyCar,
  },
  coverageConfig: {
    compCollCopy: {
      description:
        'We have combined these coverages for your benefit. You depend on your car and we want to ensure you are covered for a variety of scenarios (Hail storms, fender benders, and broken windshields are just a few examples). This coverage is required for leased or financed vehicles.',
    },
    tenantAssetsImg: carvanaCoverageShield,
    tenantLoveImg: carvanaFamily,
    tenantVehicleImg: carvanaSmileyCarWithSparkles,
  },
  coverageStartDateConfig: {
    infoCopy: null,
    labelCopy:
      'This date should be the same day as your appointment with Carvana',
    regionLabelCopy: {
      SC: 'This date should be one day prior to your appointment with Carvana.',
    },
  },
  cssFiles: ['carvana.css'],
  discountsConfig: {
    hasPartnerDiscount: true,
  },
  errorPageConfig: {
    backgroundImgSrc: null,
  },
  featureFlags: {
    isAccountManagementEnabled: false,
    isAutoPurchaseFlowEnabled: true,
    isAutoQuoteLinkExchangeEnabled: true,
    isDirectToAutoQuoteEnabled: false,
    isLogoRedirectInAutoPurchaseFlowEnabled: true,
    isPrivacyAndTermsEnabled: true,
    isQuoteAssistForTenantEnabled: false,
    isRentersQuoteCreationEnabled: false,
    isSelfServiceEnabled: false,
  },
  footerConfig: {
    hasNavItems: false,
    hasSocialLinks: true,
    sureFooterLogoSrc: '',
  },
  iconConfig: {
    isShowAlertIcon: true,
    isShowDriverIcon: false,
    isShowVehicleIcon: false,
  },
  icons: {
    TenantAlertIcon,
    TenantCarIcon: null,
    TenantVehicleIcon: null,
    trustIcons: [
      'pf-visa',
      'pf-mastercard-alt',
      'pf-american-express-alt',
      'pf-discover',
    ],
  },
  layoutContentConfig: {
    tenantCityImg,
  },
  layoutQuoteConfig: {
    isLogoHeader: true,
    summaryPosition: 'sticky',
    variant: '100vw-footer',
  },
  localforageDbName: 'carvana',
  logos: {
    default: carvanaCobrandLogo,
    light: carvanaCobrandLogo,
    title: 'Carvana Co-brand Logo',
  },
  mfaConfig: {
    secondaryButtonType: 'OUTLINE',
    submitButtonType: 'PRIMARY',
  },
  modalAdjustedPriceConfig: {
    footerButtonVariant: 'PRIMARY',
  },
  // modalRemoveVehicleOrDriverConfig: {
  //   secondaryButtonType: 'OUTLINE',
  //   submitButtonType: 'PRIMARY',
  // },
  navBarConfig: {
    hasNavBarItems: false,
  },
  notifyConfig: {
    discountCopy:
      'Congratulations on your new car and unlocking Carvana exclusive savings with Toggle Insurance!',
  },
  passwordValidator: {
    passingIconType: 'circle-fill',
  },
  primaryVehicleDataSource: 'carvana',
  purchaseFlowConfig: {
    isCheckoutToggleCustomerDefault: false,
  },
  quoteExpirationCondition: {
    maxElapsedTimeMinutes: 60,
    onConfirmDestination: 'https://www.carvana.com/',
    timestampKey: 'created_at',
  },
  redirectUrls: {
    indexRedirectUrl: 'https://www.carvana.com/',
    mfaSuccessRedirectUrl: `${mfaSuccessHost}my-account`,
    isPartnerRedirectUrlEnabled: true,
  },
  reviewAutoQuoteConfig: {
    additionalHeader: 'Built for you, by you. Now take a moment to review.',
  },
  signUpViewConfig: {
    // TODO assuming since this is in v2, this is not currently used. If we do end up using this config we'll need to make a carvana.tsx in the copy constants fodler
    formDisclaimer:
      "We may obtain your credit information and other third party consumer reports (like your driving record) in connection with this application for insurance. Don't worry, getting your price will not affect your credit score.",
    header:
      "Congrats on choosing the New Way to Buy a Car® from Carvana! Now get auto insurance and peace of mind in minutes. Our insurance is fully customizable so you don't have to pay for coverage you don't need.",
    hero2: "Let's go",
    heroVariant: 'small',
    informationalHeader: 'But first...',
    informationalSubHeader: 'Confirm the details below.',
  },
  stripeElStyles: {
    base: {
      '::placeholder': {
        color: '#9b9b9b8a',
      },
      color: '#757989',
      fontFamily: "'Carvana Type', Helvetica, sans-serif",
      fontSize: '14px',
    },
    invalid: {
      iconColor: '#ff7171',
      color: '#757989',
    },
  },
  tenantDisplayName: 'Carvana',
  tenantPhoneNumber: '',
  vehicleManagementCopyConfig: {
    subheader:
      "We've already included your new vehicle with Carvana. Feel free to add additional vehicles.",
  },
};

export default config;
